import EventEmitter from 'events';

class NodeEmitter extends EventEmitter {}

export default new NodeEmitter();
